if (!customElements.get("product-inventory")) {
  class t extends HTMLElement {
    constructor() {
      super(), window.initLazyScript(this, this.initLazySection.bind(this));
    }
    initLazySection() {
      (this.threshold = parseInt(this.dataset.threshold, 10)),
        (this.productInventory = this.querySelector(".product-inventory")),
        (this.inventoryNotice = this.querySelector(
          ".product-inventory__status"
        )),
        (this.variantInventory = this.getVariantInventory()),
        this.closest(".js-product").addEventListener(
          "on:variant:change",
          this.handleVariantChange.bind(this)
        );
    }
    getVariantInventory() {
      let t = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(t.textContent);
    }
    handleVariantChange(t) {
      this.updateInventory(
        t.detail.variant
          ? this.variantInventory.find((e) => e.id === t.detail.variant.id)
          : null
      );
    }
    updateInventory(t) {
      if (!t) {
        this.productInventory.hidden = !0;
        return;
      }
      let e = t.inventory_quantity,
        n =
          "always" === this.dataset.showInventoryCount ||
          ("low" === this.dataset.showInventoryCount && e <= this.threshold),
        i = null;
      (i = n
        ? e <= this.threshold
          ? this.dataset.textXLeftLow.replace("[QTY]", e)
          : this.dataset.textXLeftOk.replace("[QTY]", e)
        : e <= this.threshold
        ? this.dataset.textLow
        : this.dataset.textOk),
        this.productInventory.classList.toggle(
          "product-inventory--low",
          e <= this.threshold
        ),
        this.productInventory.classList.toggle(
          "product-inventory--ok",
          e > this.threshold
        ),
        this.querySelector(".product-inventory__icon-low").toggleAttribute(
          "hidden",
          e > this.threshold
        ),
        this.querySelector(".product-inventory__icon-ok").toggleAttribute(
          "hidden",
          e <= this.threshold
        ),
        (this.inventoryNotice.innerText = i),
        (this.productInventory.hidden = !1);
    }
  }
  customElements.define("product-inventory", t);
}
